import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { defaultContext, getInitialStyle, MAX_ITEMS_PER_ROW, KEY_PADDING } from './subKeyboard.style';
import { KeyboardItem } from '../keyItem/keyItem.component';
import { KEY_WIDTH, KEY_HEIGHT, KEYS_GAP, getBasicLetter } from '../keyItem/keyItem.style';
import { LETTER_SELECTED_SIGNAL } from '../keyboard.constants';
import { CLOSE_SUB_KEYBOARD_SIGNAL } from './subKeyboard.constants';

export class SubKeyboard extends Lightning.Component {
  static _template() {
    return _merge(
      {
        ScalableContent: {
          Background: {
            shader: {
              type: Lightning.shaders.RoundedRectangle,
            },
          },
          Keys: {},
        },
      },
      getInitialStyle(),
    );
  }

  _init() {
    this._index = 0;
    this._items = [];
    this._style = defaultContext;
  }

  set initialize(data) {
    const { items, x, y } = data;
    this._items = items;
    let numberOfButtons = 0;
    let width;
    let height;

    if (items.length >= MAX_ITEMS_PER_ROW) {
      width = (KEY_WIDTH[this._style.screenSize] + KEYS_GAP) * MAX_ITEMS_PER_ROW;
      height = (KEY_HEIGHT[this._style.screenSize] + KEYS_GAP) * Math.floor(items.length / MAX_ITEMS_PER_ROW);
    } else {
      width = (KEY_WIDTH[this._style.screenSize] + KEYS_GAP) * items.length;
      height = KEY_HEIGHT[this._style.screenSize] + KEYS_GAP;
    }

    this.tag('Keys').children = items.map((symbol, index) => {
      numberOfButtons += 1;

      return {
        type: KeyboardItem,
        x: (KEY_WIDTH[this._style.screenSize] + KEYS_GAP) * ((numberOfButtons - 1) % MAX_ITEMS_PER_ROW),
        y: (KEY_HEIGHT[this._style.screenSize] + KEYS_GAP) * Math.floor((numberOfButtons - 1) / MAX_ITEMS_PER_ROW),
        Button: {
          SpecialIndicator: {
            visible: index === 0,
          },
        },
        ...getBasicLetter({ symbol, ...this._style }),
      };
    });

    this.patch({
      x,
      y,
      visible: true,
      ScalableContent: {
        w: width + KEY_PADDING * 2,
        h: height + KEY_PADDING * 2,
      },
    });
  }

  _reset() {
    this._index = 0;
    this._items = [];

    this.patch({
      visible: false,
      x: 0,
      y: 0,
      ScalableContent: {
        w: 0,
        h: 0,
      },
    });
    this.tag('Keys').children = undefined;
  }

  _close() {
    this.signal(CLOSE_SUB_KEYBOARD_SIGNAL);
    this._reset();
  }

  _handleUp() {
    const isNotFirstRow = this._index > MAX_ITEMS_PER_ROW - 1;
    if (isNotFirstRow) {
      this._setIndex(this._index - MAX_ITEMS_PER_ROW);

      return true;
    }
    this._close();

    return false;
  }

  _handleDown() {
    const isNotLastRow = this._index + MAX_ITEMS_PER_ROW < this._items.length;

    if (isNotLastRow) {
      this._setIndex(this._index + MAX_ITEMS_PER_ROW);

      return true;
    }
    this._close();

    return false;
  }

  _handleLeft() {
    const itemsCount = this._items.length;
    const isNotBeginningOfRow =
      itemsCount > MAX_ITEMS_PER_ROW ? this._index % MAX_ITEMS_PER_ROW !== 0 : this._index > 0;

    if (isNotBeginningOfRow) {
      this._setIndex(this._index - 1);

      return true;
    }
    this._close();

    return false;
  }

  _handleRight() {
    const itemsCount = this._items.length;
    const isNotEndOfRow =
      itemsCount > MAX_ITEMS_PER_ROW ? (this._index + 1) % MAX_ITEMS_PER_ROW !== 0 : this._index + 1 < itemsCount;

    if (isNotEndOfRow) {
      this._setIndex(this._index + 1);

      return true;
    }
    this._close();

    return false;
  }

  _handleEnter() {
    this.signal(LETTER_SELECTED_SIGNAL, this._items[this._index]);
  }

  _handleBack() {
    this._close();
  }

  _setIndex(index = this._index) {
    this._index = index;
  }

  _getFocused() {
    return this.tag('Keys').children[this._index];
  }
}
